import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Table from '../../../../core/form/Table';
import Button from '../../../../core/form/Button';
import StudentPlacementItemList from './StudentPlacementItemList';
import { round } from 'lodash';

const StudentPlacementList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Started at',
        path: 'startedAt',
        srt: true,
      },
      {
        label: 'Completed at',
        path: 'completedAt',
      },
      {
        label: 'Reached Level',
        path: 'reachedLevel.level',
        render: (cell, row) => (
          <span>
            {cell} - {get(row.reachedLevel, 'course.name', '')}
          </span>
        ),
      },
      {
        label: 'Stop Reason',
        path: 'stopReason',
      },
      {
        label: 'Type',
        path: 'type',
        render: (cell) =>
          cell
            ? {
                PLACEMENT: 'Placement Test',
                BONUS: 'Bonus Test',
              }[cell]
            : 'Placement Test',
      },
      {
        label: 'Correct Answers',
        path: 'answeredItems',
        render: (cell) => {
          const correctAnswersCount = cell.filter((answer) => answer.correct).length;
          const answersCount = cell.length;
          return `${correctAnswersCount}/${answersCount} (${round((correctAnswersCount / answersCount) * 100, 1)}%)`;
        },
      },
      ...(props.placements.length === 1 && props.placements[0].type === 'PLACEMENT'
        ? [
            {
              label: 'Actions',
              width: '70px',
              render: (cell, row) => <Button icon="delete" onClick={() => props.onDelete(row)} />,
            },
          ]
        : []),
    ]}
    rows={props.placements}
    expandableComponent={(row) => (
      <StudentPlacementItemList studentId={row.student} placementTestId={row.id} items={row.answeredItems} />
    )}
  />
);

StudentPlacementList.propTypes = {
  placements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default StudentPlacementList;
